import { render, staticRenderFns } from "./GradesModal.vue?vue&type=template&id=faf7119a&"
import script from "./GradesModal.vue?vue&type=script&lang=js&"
export * from "./GradesModal.vue?vue&type=script&lang=js&"
import style0 from "./GradesModal.vue?vue&type=style&index=0&id=faf7119a&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports